module.exports = __webpack_public_path__ + "img/Logo-01.e0a651fd.png";